import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {HttpClientService} from "../core/services/http-client.service";
import {CommonService} from "../core/services/common.service";
import {filter, map} from "rxjs/operators";


@Component({
  selector: 'app-affiliate-dashboard',
  templateUrl: './affiliate.component.html',
  styleUrl: './affiliate.component.css'
})
export class AffiliateComponent implements OnInit {
  headerHeading: string = '';
  sidebarCollapsed = false;
  customer: any;
  userCode: string;
  selectedMenu: string = '/';

  constructor(private httpService: HttpClientService, private common: CommonService, private router: Router,private activatedRoute: ActivatedRoute) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() +
      this.customer.lastName.charAt(0).toUpperCase();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute.firstChild;
        while (route?.firstChild) {
          route = route.firstChild;
        }
        return route?.snapshot.data?.['headerHeading'] || '';
      })
    ).subscribe(heading => {
      this.headerHeading = heading;
    });

  }


  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
    });

  }

  closeMobileSidebar() {
    if (window.innerWidth < 992) {
      this.sidebarCollapsed = false;
    }
  }

  makeActive(menu: string): void {
    this.selectedMenu = menu;
    if (!menu) menu = "/"
    this.router.navigateByUrl(menu);
  }

  protected readonly navigator = navigator;
}
